// Lib
import HttpStatus from 'http-status-codes';

// Utils
import { getResponseStatusCode, getErrorName } from '../../../common/error/errorUtil';

export const getExportErrorLocaleKey = (err: unknown): string => {
    const statusCode = getResponseStatusCode(err);

    if (statusCode === HttpStatus.TOO_MANY_REQUESTS) return 'errors.tooManyRequests';
    const errorName = getErrorName(err);

    if (errorName === 'LimitExceededError') return 'errors.limitExceeded';

    return 'errors.failedToCreateExport';
};
